<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      dialogIcon="mdi-check-circle-outline"
      title="Ferdigstill"
      btnActionName="Ferdigstill"
      scrollable
      @action="save"
    >
      <template v-slot>
        <CommentInpute
          v-model="comment"
          :closeDialog="!showDialog"
          :desplayShowToCostomerBtn="false"
        />
      </template>
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import CommentInpute from "@/components/shared/comments/CommentInpute.vue";

import { CommentObject } from "@/types/commentInterface";
import notification from "@/helpers/notification";
export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      comment: {
        visibleToCustomer: false,
        status: 2,
        text: "",
        attachments: [] as any,
      } as CommentObject,
    };
  },
  methods: {
    save() {
      if (this.comment?.newComment) {
        this.showDialog = false;
        //2 is ferdigtilt
        this.$emit("save", { comment: this.comment, newStatus: 2 });
      } else if (!this.comment?.newComment) {
        notification.warn("Kommentar er ikke lagt til!");
      }
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },

  components: {
    BaseDialog,
    CommentInpute,
  },
});
</script>
